// Shared chart-axis constants + tick helpers used by SmartOverlayChart
// (multi-line CPL on the dashboard) and ExpandedMetricChart (single-line
// metric drill-down on the account page). Both charts use the same
// HTML-overlay strategy for labels so axis text doesn't distort when
// the SVG stretches horizontally.

export const CHART_MARGIN_LEFT = 44;
export const CHART_MARGIN_RIGHT = 8;
export const CHART_MARGIN_TOP = 6;
export const CHART_MARGIN_BOTTOM = 22;
export const NUM_Y_TICKS = 5;

export function fmtAxisDate(iso: string): string {
  const parts = iso.split("-");
  if (parts.length !== 3) return iso;
  return `${parseInt(parts[1]!, 10)}/${parseInt(parts[2]!, 10)}`;
}

// Generic fallback formatter when the caller doesn't provide one.
// Adapts precision to the visible range so axis labels stay tight.
export function fmtAxisValue(v: number, range: number): string {
  if (range >= 100) return Math.round(v).toString();
  if (range >= 10) return v.toFixed(0);
  if (range >= 1) return v.toFixed(1);
  return v.toFixed(2);
}

// Evenly-spaced Y tick values across [yMin, yMax].
export function buildYTicks(yMin: number, yMax: number): number[] {
  const range = yMax - yMin || 1;
  return Array.from({ length: NUM_Y_TICKS }, (_, i) =>
    yMin + (i / (NUM_Y_TICKS - 1)) * range,
  );
}

// X tick indices at 0%, ~33%, ~66%, 100% of the series, deduped for
// short ranges (e.g. days=2 collapses to [0,1] not [0,0,1,1]).
export function buildXTickIndices(days: number): number[] {
  if (days <= 1) return [0];
  return Array.from(
    new Set([
      0,
      Math.round((days - 1) / 3),
      Math.round((2 * (days - 1)) / 3),
      days - 1,
    ]),
  );
}
